/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Network_Vehicles_None_OnlineInputs */

const fr_network_vehicles_none_online = /** @type {(inputs: Network_Vehicles_None_OnlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucun véhicule sur ${i?.count} en circulation`)
};

const en_network_vehicles_none_online = /** @type {(inputs: Network_Vehicles_None_OnlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No vehicle out of ${i?.count} is in service`)
};

/**
* | output |
* | --- |
* | "No vehicle out of {count} is in service" |
*
* @param {Network_Vehicles_None_OnlineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicles_none_online = /** @type {((inputs: Network_Vehicles_None_OnlineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicles_None_OnlineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicles_none_online(inputs)
	return en_network_vehicles_none_online(inputs)
});